module.exports = __webpack_public_path__ + "static/img/icon_cloud_p1.8cc039f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_p1.jpg
// module id = lptk
// module chunks = 21